<template>
    <div>
        <Slider class="download-navigation"
            :mousewheel-control="true"
            :dragEnable="true"
            :performance-mode="false"
        >
        <!-- 上 -->
        <div class="download-navigation-t">
            <div class="center-wrapper">
                <h1>森果零售通</h1>
                <p>手机上的零售后台，随时随地管理店铺</p>
                <!-- <p>添加商品/店铺数据/查看订单</p> -->
                <div class="btn-wrapper">
                    <button class="btn download-shanghutong"
                        style="width: 140px"
                        @click="toDownload('app')">
                        <div class="ml-0">
                            <p class="fs-20">APP下载</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="img-wrapper">
                <img class="big-img" :src="icons.mobileBackstageIcon" alt="">
                <img v-for="(value, key) in mobileBackstageIcons"
                    class="img-icon"
                    :key="key"
                    :src="value"
                    :alt="key"
                    :class="key"
                    :ref="key">
            </div>
            <div class="white-mask"></div>
            <img class="xiala" :src="icons.other.xiala" alt="">
        </div>
        <!-- 下 -->
        <div class="download-navigation-b">
            <div class="center-wrapper">
                <h1>森果收银台</h1>
                <p>三分钟快速上手，高效收银，提升经营效率</p>
                <div class="btn-wrapper">
                    <button class="fx-v-center btn download-windows"
                         @click="toDownload('windows')">
                            <i class="iconfont iconwindows fs-24"/>
                            <div>
                                <p>windows</p>
                                <p>下载</p>
                            </div>
                    </button>
                    <button class="btn download-android"
                        @click="toDownload('android')">
                        <i class="iconfont iconandroid fs-24"/>
                        <div>
                            <p>Android</p>
                            <p>下载</p>
                        </div>
                    </button>
                </div>
            </div>
            <div class="img-wrapper">
                <img class="big-img" :src="icons.cashierIcon" alt="">
                <img v-for="(value, key) in cashierIcons"
                    class="img-icon"
                    :key="key"
                    :src="value"
                    :alt="key"
                    :class="key"
                    :ref="key">
            </div>
            <div class="white-mask top"></div>
            <img class="xiala" :src="icons.other.xiala" alt="">
        </div>
    </Slider>
    <div class="zhixiang" v-if="flag1" @click="flag1 = false">
        <div class="appBox ">
            <div class="img">
                <img src="../../assets/images/zhixiang.svg" alt="">
            </div>
            <p>请在浏览器中打开并下载APP</p>
        </div>
    </div>
    </div>
</template>

<script lang="ts">
import { createComponent, ref, computed, onBeforeUnmount, onBeforeMount, onMounted, reactive } from '@vue/composition-api'
import { openMessage } from '../../utils/system'
import domain from '@/config/domain'
import Qrcode from 'qrcode'
import Slider from 'vue-plain-slider'
import { judgeClient, isWX } from '@/utils'

// icons
// @ts-ignore
import cashierIcon from './images/syt.png'
// @ts-ignore
import mobileBackstageIcon from './images/lst.png'
// @ts-ignore
import ddjm from './images/ddjm.svg'
// @ts-ignore
import sd from './images/sd.svg'
// @ts-ignore
import hywf from './images/hywf.svg'
// @ts-ignore
import money from './images/money.svg'
// @ts-ignore
import lsgj from './images/lsgj.svg'
// @ts-ignore
import ssqz from './images/ssqz.svg'
// @ts-ignore
import vip from './images/vip.svg'
// @ts-ignore
import jjb from './images/jjb.svg'
// @ts-ignore
import jssy from './images/jssy.png'
// @ts-ignore
import ckdd from './images/ckdd.svg'
// @ts-ignore
import tjhpicon from './images/tjhpicon.svg'
// @ts-ignore
import dpsj from './images/dpsj.svg'
// @ts-ignore
import ckddicon from './images/ckddicon.svg'
// @ts-ignore
import dpsjicon from './images/dpsjicon.svg'
// @ts-ignore
import tjhp from './images/tjhp.svg'
// @ts-ignore
import xiala from './images/xiala.svg'
import $fetch from '../../api'

export default createComponent({
    setup: (props, ctx) => {
        const shanghutongSrc = ref('')
        const urls = ref<{
            retail_app_url: string,
            cashier_app_url: string
            windows_cashier_app_url: string
        }>({
            retail_app_url: '',
            cashier_app_url: '',
            windows_cashier_app_url: ""
        })

        const icons = computed(() => {
            return {
                cashierIcon,
                mobileBackstageIcon,
                other: {
                    xiala
                }
            }
        })

        const cashierIcons = computed(() => {
            return {
                ddjm,
                sd,
                hywf,
                money,
                lsgj,
                ssqz,
                vip,
                jjb,
                jssy
            }
        })

        const mobileBackstageIcons = computed(() => {
            return {
                ckdd,
                tjhpicon,
                dpsj,
                ckddicon,
                dpsjicon,
                tjhp
            }
        })


        const flag1 = ref(false)

        onBeforeMount(() => {
            getShanghutongSrc()
        })

        onMounted(() => {
            getRetailAppupdateUrl()
            getCashierAppUpdateUrl()
            getWindowsCashierDownloadUrl()
            iconRunDelay()

            document.body.addEventListener('touchmove', preventDefaultEvent)
        })

        onBeforeUnmount(() => {
            document.body.removeEventListener('touchmove', preventDefaultEvent)
        })

        function preventDefaultEvent(e) {
            e.preventDefault()
        }

        async function getRetailAppupdateUrl() {
            try {
                const result = await $fetch.post({
                    url: '/common/retailappversiondetail'
                })
                console.log('商户通下载链接', result)
                urls.value.retail_app_url = result.app_url
            } catch (e) {
                openMessage('error', e.message || '获取商户通下载链接失败')
            }
        }

        function getWindowsCashierDownloadUrl() {
            $fetch.post({
                url: '/common/cashierappversiondetail',
                params: {
                    type: 2
                }
            }).then(data => {
                urls.value.windows_cashier_app_url = data.app_url
            }).catch(e => {
                openMessage('error', e.message || '获取windows收银台下载链接失败')
            })
        }

        async function getCashierAppUpdateUrl() {
            try {
                const result = await $fetch.post({
                    url: '/common/cashierappversiondetail'
                })
                console.log('收银台下载链接', result)
                urls.value.cashier_app_url = result.app_url
            } catch (e) {
                openMessage('error', e.message || '获取收银台下载链接失败')
            }
        }

        function iconRunDelay() {
            Object.keys(ctx.refs).forEach(k => {
                if (ctx.refs[k][0] instanceof Image) {
                    ctx.refs[k][0].style.animationDelay = Math.random() * 4 + 's'
                }
            })
        }

        function getShanghutongSrc() {
            Qrcode.toDataURL(`${domain.cashierMobile}#/download`, (err, url) => {
                if (err) {
                    return openMessage('error', '生成商户通二维码失败')
                }
                shanghutongSrc.value = url
            })
        }

        function toDownload(type) {

            if (isWX()) {
                // this.appPopper.current && this.appPopper.current.open()
                return flag1.value = true
            }
            if ( judgeClient() === 'Android' ) {
                switch (type) {
                    case 'android':
                        window.location.href = urls.value.cashier_app_url
                        break
                    case 'app':
                        window.location.href = urls.value.retail_app_url
                        break
                    case 'windows':
                        window.location.href = urls.value.windows_cashier_app_url
                        break
                    default:
                        break
                }
            }
            if (judgeClient() === 'IOS') {
                 switch (type) {
                    case 'android':
                        window.location.href = urls.value.cashier_app_url
                        break
                    case 'app':
                        window.location.href = 'https://apps.apple.com/cn/app/%E6%A3%AE%E6%9E%9C%E9%9B%B6%E5%94%AE%E9%80%9A/id1493885127?ign-mpt=uo%3D4'
                        break
                    case 'windows':
                        window.location.href = urls.value.windows_cashier_app_url
                        break
                    default:
                        break
                }
            }
           
            
            
        }

        function onSlideChangeStart() {
            //
        }

        return {
            // data
            urls,
            shanghutongSrc,
            icons,
            cashierIcons,
            mobileBackstageIcons,
            // methods
            toDownload,
            flag1,
            onSlideChangeStart
        }
    },

    components: {
        Slider
    }
})
</script>

<style lang="scss" scoped>

html,body,#app,.wx-pages{
    padding: 0;
    margin: 0;
    height: 100%;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
}
.download-navigation {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    color: #333;
    overflow: auto;

    * {
        -webkit-tap-highlight-color: transparent;
        -webkit-overflow-scrolling: touch;
    }

    &-t {
        // position: relative;
        background-image: linear-gradient(180deg, #F5F8F8 0%, #EBEBEB 100%);
        box-shadow: 0 -50px 80px 0 #FFFFFF;

        > .xiala {
            bottom: 12px;
            animation: xialaRunTop 1s ease-out 0s infinite alternate both;
        }

    }

    &-b {
        background-image: linear-gradient(180deg, #F5F8F8 0%, #EBEBEB 100%);
        box-shadow: 0 -50px 80px 0 #FFFFFF;

        > .xiala {
            top: 12px;
            animation: xialaRunBottom 1s ease-out 0s infinite alternate both;
        }
    }

    @keyframes xialaRunBottom {
        0% {
            transform: translate(-50%, 5px) rotate(180deg);
        }
        100% {
            transform: translate(-50%, -5px) rotate(180deg);
        }
    }

    @keyframes xialaRunTop {
        0% {
            transform: translate(-50%, 5px);
        }
        100% {
            transform: translate(-50%, -5px);
        }
    }

    &-t,
    &-b {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        > .white-mask {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 144px;
            background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 0%, #FFFFFF 87%);
        }

        > .xiala {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
        }

        > .center-wrapper {
            position: absolute;
            top: 10%;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            text-align: center;
            z-index: 1;

            > h1 {
                font-size: 30px;
                font-weight: 600;
                line-height: 42px;
            }

            > p {
                font-size: 14px;
                line-height: 20px;
                margin-top: 4px;

                &:nth-of-type(2) {
                    font-size: 10px;
                    line-height: 14px;
                    color: #999;
                }
            }

            > .btn-wrapper {
                width: 100%;
                margin-top: 20px;
                text-align: center;

                .btn {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    width: 120px;
                    height: 50px;
                    margin-right: 40px;
                    background-color: #fff;
                    color: #333;
                    box-shadow: 0 4px 20px -4px rgba(0, 0, 0, .1);
                    border-radius: 30px;
                    text-align: center;
                    outline: none;
                    cursor: pointer;

                    &:hover {
                        transform: scale(1.05);
                        color: #707070;
                    }

                    &:active {
                        background-color: rgba(0, 0, 0, .1);
                    }

                    div {
                        line-height: 16px;
                        margin-left: 7px;
                        font-size: 16px;
                        font-weight: 600;
                        text-align: left;

                        p:nth-child(2) {
                            font-size: 12px;
                            margin-top: 1px;
                        }
                    }

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }

        > .img-wrapper {
            position: relative;
            top: -47px;
            display: flex;
            align-items: flex-end;
            width: 100%;
            text-align: center;

            > .big-img {
                width: 100%;
            }

            @keyframes iconRun {
                0% {
                    transform: translate(-20px, 10px) scale(.8);
                }
                100% {
                    transform: translate(-20px, -10px) scale(.8);
                }
            }

            > .img-icon {
                position: absolute;
                transform: scale(.8);
                animation: iconRun 2s ease-out 0s infinite alternate both;

                &.ddjm {
                    left: 3%;
                    bottom: 12%;
                }

                &.sd {
                    left: 12%;
                    bottom: 41%;
                }

                &.hywf {
                    left: 20%;
                    bottom: 58%;
                }

                &.lsgj {
                    left: 33%;
                    bottom: 46%;
                }

                &.money {
                    left: 38%;
                    bottom: 60%;
                }

                &.ssqz {
                    left: 57%;
                    bottom: 60%;
                }

                &.vip {
                    left: 62%;
                    bottom: 46%;
                }

                &.jjb {
                    left: 70%;
                    bottom: 28%;
                }

                &.jssy {
                    left: 71%;
                    bottom: 2%;
                }

                &.ckdd {
                    left: 22%;
                    bottom: 56%;
                }

                &.tjhpicon {
                    left: 58%;
                    bottom: 53%;
                }

                &.dpsj {
                    left: 10%;
                    bottom: 36%;
                }

                &.ckddicon {
                    left: 8%;
                    bottom: 48%;
                }

                &.dpsjicon {
                    left: 62%;
                    bottom: 12%;
                }

                &.tjhp {
                    left: 70%;
                    bottom: 58%;
                }
            }
        }
    }

}

.zhixiang {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 9999;
    touch-action: none;

//    > img {
//         display: inline-block;
//         width: 86px;
//         height: 175px;
//     }

    .appBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 210px;
        padding: 0 40px;


        .img {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            // display: inline-block;
            // text-align: right;
            height: 200px;

            img {
                display: inline-block;
                width: 86px;
                height: 175px;
            }
        }

        p {
            text-align: center;
            color: #fff;
            font-size: 16px;
        }

    }
}
</style>
